module.exports = "<p>\n  menu works!\n</p>\n"